import { request } from "../request";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";

// 获取带有笔记的课程列表
export const getCourseWithNotes = (params) =>
  request(`${mock}/v1/userCourse/notes/getList`, "get", {
    params,
  });

// 获取课程的笔记列表（按单元分组）
export const getCourseNotes = (params) =>
  request(`${mock}/v1/userCourse/notes/getNotesByCourseId`, "get", {
    params,
  });

// 删除笔记
export const deleteNote = (params) =>
  request(`${mock}/v1/userCourse/notes/delete`, "get", {
    params,
  });

// 笔记详情
export const getNoteDetail = (params) =>
  request(`${mock}/v1/userCourse/notes/getByLessonId`, "get", {
    params,
  });

//保存课时笔记
export const saveNote = (params) =>
  request(`${mock}/v1/userCourse/notes/save`, "post", {
    json: params,
  });

//导出用户课时笔记
export const exportNote = (params) =>
  request(
    `${mock}/v1/userCourse/notes/export`,
    "get",
    {
      params,
    },
    50 * 1000
  );
